export default "__VITE_ASSET__cKWpAYT1__"